import { format } from "date-fns-tz";

export const standardDateFormat = "MM/dd/yyyy";

export const dateToStandardFormat = (dateTime: Date | undefined): string => {
  if (dateTime) {
    return format(dateTime, standardDateFormat);
  }
  return "";
};
